export default __webpack_public_path__ + "static/media/first.68128530.jpg";